import React from "react";
import { BrowserRouter } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import ScrollToTop from "./components/Layout/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout />
    </BrowserRouter>
  );
}

export default App;
